import { render } from "./LoginAccount.vue?vue&type=template&id=2418e9b6"
import script from "./LoginAccount.vue?vue&type=script&lang=js"
export * from "./LoginAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__